/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/trash_medium'
export default icon
